import axios from "axios";
import { api } from "core/axios/axios";

export async function getWidgets() {
    return api.get("widgets");
}

export async function createWidget(body: any) {
    body.json_content = JSON.stringify(body.json_content);
    return api.post(`widgets`, body);
}


export async function updateWidget(body: any, id: any) {
    body.json_content = JSON.stringify(body.json_content);
    return api.put(`widgets/${id}`, body);
}

export async function deleteWidget(id: string) {
    return api.delete(`widgets/${id}`);
}


export async function getWidgetData(url: string) {
    return axios.get(url);
}